@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.root {
  outline: none;
  margin: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;

  &.useFullWidth {
    width: 100%;
  }
}

.sectionHeading {
  @include sm-regular;
  color: $grey-40;
  margin: 8px 8px 4px 8px;
  display: block;

  [data-autopilot-system-redesign='on'] & {
    span {
      font-weight: 500 !important;
      color: var(--dark-40) !important;
    }
  }
}

.separator {
  height: 1px;
  margin: 4px 8px;
  list-style: none;
  background: var(--dark-4);
}
